/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React from 'react';
import {createRoot} from 'react-dom/client';
import './common/styles/style.css';
import Mapcomponent from './routes/interactive-map/pages/Mapcomponent.js';

import './common/styles/index.scss';


const App = ({ route, vocabularyId, contentKey, googleMapAPIKey}) => {
    return (
        <div>
            <Mapcomponent vocabularyId={vocabularyId} contentKey={contentKey} googleMapAPIKey={googleMapAPIKey}/>
        </div>
    );
};


class WebComponent extends HTMLElement {

	connectedCallback() {
		this.root = createRoot(this);

		this.root.render(<App route={this.getAttribute('route')} vocabularyId={this.getAttribute('VocabularyId')} contentKey={this.getAttribute('ContentKey')} googleMapAPIKey={this.getAttribute('GoogleMapAPIKey')} />, this);

	}

	disconnectedCallback() {

		this.root.unmount();
		delete this.root;
	}
}

const ELEMENT_ID = 'dubai-health-interactive-map';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
